var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 card" }, [
    _c("div", { staticClass: "card-header bg-secondary-3" }, [
      _vm._v(" Dominio Evaluado: "),
      _c("b", [_vm._v(_vm._s(_vm._f("empty")(_vm.value.area.name)))])
    ]),
    _c("div", { staticClass: "card-body bg-secondary-3" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-1" },
          [
            _c("label", { staticClass: "data-name" }, [_vm._v("Puntuación:")]),
            _c("validation-provider", {
              ref: "score",
              attrs: {
                name: `Puntuación-${_vm.value.area.id}`,
                rules: "required|between:0,100"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors, failedRules }) {
                    return [
                      _c("custom-input", {
                        ref: "scoreInput",
                        staticClass: "w-100",
                        attrs: {
                          "custom-error-msg": _vm.getErrorMessage(failedRules),
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          placeholder: "0-100"
                        },
                        on: { input: _vm.changeScore },
                        model: {
                          value: _vm.scoreText,
                          callback: function($$v) {
                            _vm.scoreText = $$v
                          },
                          expression: "scoreText"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm.isEvaluatedResults
          ? _c("div", { staticClass: "col-md-2" }, [
              _c("label", { staticClass: "data-name" }, [_vm._v("Nivel:")]),
              _vm.level
                ? _c("div", { staticClass: "mt-1" }, [
                    _c(
                      "span",
                      {
                        staticClass: "rounded-pill px-3 py-1 fw-semibold",
                        style: _vm.badge
                      },
                      [_vm._v(" " + _vm._s(_vm.level.name) + " ")]
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-md" }, [
          _vm.isEvaluatedResults
            ? _c(
                "div",
                [
                  _c("label", { staticClass: "data-name" }, [
                    _vm._v("Interpretación:")
                  ]),
                  _c("custom-input", {
                    attrs: { disabled: _vm.isReadOnly },
                    model: {
                      value: _vm.model.comment,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "comment", $$v)
                      },
                      expression: "model.comment"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isWhodasCifCodes
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { staticClass: "data-name" }, [
                        _vm._v(" Dificultad Leve (Calificador 1): ")
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      disabled: _vm.isReadOnly,
                                      error: errors[0]
                                    },
                                    model: {
                                      value: _vm.model.qualifierOne,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "qualifierOne", $$v)
                                      },
                                      expression: "model.qualifierOne"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          725812287
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { staticClass: "data-name" }, [
                        _vm._v(" Dificultad Moderada (Calificador 2): ")
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      disabled: _vm.isReadOnly,
                                      error: errors[0]
                                    },
                                    model: {
                                      value: _vm.model.qualifierTwo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "qualifierTwo", $$v)
                                      },
                                      expression: "model.qualifierTwo"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2755515991
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { staticClass: "data-name" }, [
                        _vm._v(" Dificultad Grave (Calificador 3): ")
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      disabled: _vm.isReadOnly,
                                      error: errors[0]
                                    },
                                    model: {
                                      value: _vm.model.qualifierThree,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "qualifierThree",
                                          $$v
                                        )
                                      },
                                      expression: "model.qualifierThree"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          79561365
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-2" },
                    [
                      _c("label", { staticClass: "data-name" }, [
                        _vm._v("Descripción Observaciones:")
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      disabled: _vm.isReadOnly,
                                      error: errors[0]
                                    },
                                    model: {
                                      value: _vm.model.comment,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comment", $$v)
                                      },
                                      expression: "model.comment"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          156287408
                        )
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }